"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.toPascalCase = toPascalCase;
require("core-js/modules/es.array.join.js");
require("core-js/modules/es.array.map.js");
require("core-js/modules/es.regexp.exec.js");
require("core-js/modules/es.string.replace.js");
// 改写大驼峰：close-fill -> CloseFill
function toPascalCase(str) {
  return str.split('-').map(function (item) {
    var temp = item.replace(/^([a-z])/, function (x) {
      return x.toUpperCase();
    });
    return temp;
  }).join('');
}